import AddBroker from '@/graphql/AddBroker.gql'
import GetBrokers from '@/graphql/GetBrokers.gql'

import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async saveBroker ({ commit, dispatch }, broker) {
    let response
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: AddBroker,
        variables: {
          broker: broker
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El asesor se ha guardado exitosamente' })
      response = true
      return data.saveBroker
    } catch (error) {
      dispatch('showError', error)
      response = false
    }
    return response
  },

  async getBrokers ({ commit, dispatch }, { pageNumber, perPage, order }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetBrokers,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber: pageNumber,
          perPage: perPage,
          order
        }
      })
      return data.Brokers
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
